
export const socialLinks = [
    {
        icon: 'mail',
        target: 'mailto:info@byzans.com',
        links: {
            icon: require('./images/mail.svg'),
            icon_inverted: require('./images/mail_inverted.svg'),
            icon_inverted_hover: require('./images/mail_inverted_hover.svg'),
            icon_hover: require('./images/mail_hover.svg'),
        }
    },
    {
        icon: 'instagram',
        target: 'https://instagram.com/byzans.app',
        links: {
            icon: require('./images/instagram.svg'),
            icon_inverted: require('./images/instagram_inverted.svg'),
            icon_inverted_hover: require('./images/instagram_inverted_hover.svg'),
            icon_hover: require('./images/instagram_hover.svg'),
        }
    },
    {
        icon: 'facebook',
        target: 'https://www.facebook.com/ByzansApp/',
        links: {
            icon: require('./images/facebook.svg'),
            icon_inverted: require('./images/facebook_inverted.svg'),
            icon_inverted_hover: require('./images/facebook_inverted_hover.svg'),
            icon_hover: require('./images/facebook_hover.svg'),
        }
    },
    {
        icon: 'twitter',
        target: 'https://twitter.com/ByzansApp',
        links: {
            icon: require('./images/twitter.svg'),
            icon_inverted: require('./images/twitter_inverted.svg'),
            icon_inverted_hover: require('./images/twitter_inverted_hover.svg'),
            icon_hover: require('./images/twitter_hover.svg'),
        }
    }
]